module.exports = __webpack_public_path__ + "static/banner.99dabf1a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/banner.mp4
// module id = 428
// module chunks = 35783957827783